<template>
  <path
    d="M2.66663 6.66667C2.66663 4.15251 2.66663 2.89543 3.44767 2.11438C4.22872 1.33334 5.4858 1.33334 7.99996 1.33334C10.5141 1.33334 11.7712 1.33334 12.5522 2.11438C13.3333 2.89543 13.3333 4.15251 13.3333 6.66667V9.33334C13.3333 11.8475 13.3333 13.1046 12.5522 13.8856C11.7712 14.6667 10.5141 14.6667 7.99996 14.6667C5.4858 14.6667 4.22872 14.6667 3.44767 13.8856C2.66663 13.1046 2.66663 11.8475 2.66663 9.33334V6.66667Z"
    stroke="currentColor" />
  <path d="M10 12.6667H6" stroke="currentColor" stroke-linecap="round" />
</template>
